import { render, staticRenderFns } from "./Ecommerce.vue?vue&type=template&id=7213eaf8&scoped=true"
import script from "./Ecommerce.vue?vue&type=script&lang=js"
export * from "./Ecommerce.vue?vue&type=script&lang=js"
import style0 from "./Ecommerce.vue?vue&type=style&index=0&id=7213eaf8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7213eaf8",
  null
  
)

export default component.exports